import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";
import { store } from "@/store";
import StoreGetter from "@/constants/StoreGetter";
const MenuRightService = {
  hasRightInMenu(menuRights, menuId, key) {
    try{
      const hasRight = store.getters[StoreGetter.sysMenu].find(
        x => x.MenuID === menuId
      )[key];
      return hasRight;
    } catch (e) {
      return false;
    }
  },
  getMenuRights(obj) {
    return httpClient.post(endPoints.getMenuRightForUser, obj);
  }
};

export default MenuRightService;



// WEBPACK FOOTER //
// ./src/service/MenuRightService.js